interface ICookie {
    expirationDate?: Date;
    value: string;
    name: string;
}

abstract class ICookiesService {
    public abstract getCookie(name: string) : string;

    public abstract setCookie(cookie: ICookie);

    public abstract deleteCookie(name: string);
}

export { ICookiesService, ICookie };